/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const calendar = require('components/common/data-calendar/data-calendar');
const echarts = require('echarts');
const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp');
const tip = require('components/base/pop/tip');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const { apiPath } = require('appService/api');

const template = require('./user-survey.tpl');
require('./user-survey.scss');

const UserSurvey = {
	name:"user-survey",
	template,
	data() {
		return {
			searchMonth: [
				{
					value: -1,
					text: "请选择月份"
				},
				{
					value: 1,
					text: "一月"
				},
				{
					value: 2,
					text: "二月"
				},
				{
					value: 3,
					text: "三月"
				},
				{
					value: 4,
					text: "四月"
				},
				{
					value: 5,
					text: "五月"
				},
				{
					value: 6,
					text: "六月"
				},
				{
					value: 7,
					text: "七月"
				},
				{
					value: 8,
					text: "八月"
				},
				{
					value: 9,
					text: "九月"
				},
				{
					value: 10,
					text: "十月"
				},
				{
					value: 11,
					text: "十一月"
				},
				{
					value: 12,
					text: "十二月"
				}
			],
			url: apiPath.usersurvey.querySurvey,
			newUserEchart:{},
			baseInfo:{},
			timeVal:0,
			calendar:{
        show:false,
        x:0,
        y:0,
        picker:"",
        type:"date",
        value:"",
        sep:"-",
        range:false,
        end:'',
        begin:'',
        items:{
          startTime:{
            type:"date",
            begin:'',
            end:new Date().getFullYear()+'-'+(1+new Date().getMonth())+'-'+new Date().getDate(),
            value:"",
            sep:"-"
          },
          endTime:{
            type:"date",
            begin:'',
            end:new Date().getFullYear()+'-'+(1+new Date().getMonth())+'-'+new Date().getDate(),
            value:"",
            sep:"-"
          }
        }
      },
      echartOption:{
  			color:["#ff7235","#4ca9d4","#5867c3"],
		    tooltip: {
		      trigger: 'axis'
		    },
		    legend: {
	        data:['Android','ios','合计'],
	        right:'5%',
	        itemWidth: 10,
	        itemHeight:10,
	        itemGap:22,
	        data: [
	        	{
				      name: "合计",
				      icon: 'roundRect'
				    },{
				      name: "ios",
				      icon: 'roundRect'
				    },
				    {
				      name: "Android",
				      icon: 'roundRect'
				    }
				  ]
		    },
		    grid: {
	        left: '3%',
	        right: '4%',
	        containLabel: true
		    },
		    xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        axisLine:{
	        	lineStyle:{
	        		opacity: 0.4
	        	}
	        },
	        data: []
		    },
		    yAxis: {
	        type: 'value',
	        axisLine:{
	        	lineStyle:{
	        		opacity: 0.4
	        	}
	        },
		    },
		    series: [
		    	{
	            name:'合计',
	            type:'line',
	            data:[]
	        },
	        {
	            name:'ios',
	            type:'line',
	            data:[]
	        },
	        {
	            name:'Android',
	            type:'line',
	            data:[]
	        }
		    ]
			}
		}
	},
	ready(){
		this.newUserEchart = echarts.init(document.getElementById('newuser-gui'));
		this.searchData();
	},
	route: {
    data: (transition) => {
      document.title = '用户数据'
      transition.next()
    }
	},
	watch:{
		'calendar.value': function (value) {
				this.calendar.items[this.calendar.picker].value=value;
    }
	},
	components:{
		calendar
	},
	methods: {
		searchData(){
			let args={
				startTime:this.calendar.items.startTime.value,
				endTime:this.calendar.items.endTime.value
			};
			ajaxHttp(this.url, {
			    type: "get",
			    data: args
			}).then((res)=> {
		      let rData = res.data;
		      this.baseInfo = rData.statistics;

		      this.newUserEchart.setOption(this.formatGuiData(rData));
		  }).catch((err) => {
		  	tip(err);
		  })
		},
		formatGuiData(dataCol){
			let _data = dataCol;
			let _obj = Object.assign({},this.echartOption);

			//x轴时间线
			let _time = this.formatGuiVal(_data.android,"time");

			let _android = this.formatGuiVal(_data.android,"value");
			let _ios = this.formatGuiVal(_data.ios,"value");
		  _obj.xAxis.data = _time;
		  _obj.series[1].data = _ios;
		  _obj.series[2].data = _android;
		  _obj.series[0].data = this.arrayComb(_android,_ios);

		  return _obj;
		},
		formatGuiVal(data,type){
			let _data = data;
			let _arr=[];
			for(let item of _data){
				_arr.push(item[type]);
			}
			return _arr;
		},
		arrayComb(a,b){
			if(a.length != b.length){
				console.log("相加的两个数组长度不相等");	
				return [];
			}
		  return a.map(function(e, i){
		    return e+b[i];
		  });
		},

		timeSet(type, i){
			let startT  = "";
			let endT = this.formatDay(0);;
			if(type === 1) {
				this.timeVal = i;
				if(i==7){
					startT = this.formatDay(i);
				}else{
					if(i==30){
						startT = this.formatDayByMonth(1);
					}else{
						startT = this.formatDayByMonth(12);
					}
				}
			} else if(type === 2) {
				let _monthVal = i;
				startT = this.getMonthStartDay(_monthVal);
				endT = this.getMonthEndDay(_monthVal);
			}
			this.calendar.items.startTime.value = startT;
			this.calendar.items.endTime.value = endT;
		},
		formatTime: function (time) {
			let dTime = new Date(time),
				dMinutes = dTime.getMinutes();
			dMinutes = dMinutes < 10 ? "0" + dMinutes : dMinutes;
			return `${dTime.getFullYear()}-${dTime.getMonth() + 1}-${dTime.getDate()}  ${dTime.getHours()}:${dMinutes}`;
		},
		//天数日期转换
		formatDay: function(t,ac='-'){
			let t1 = new Date(new Date().getTime() - t*24*60*60*1000);
			return `${t1.getFullYear()}${ac}${(1+t1.getMonth())}${ac}${t1.getDate()}`;
		},
		//按月获取
		formatDayByMonth: function(t,ac='-'){
			let tgDate = new Date(),
					tgMonth = tgDate.getMonth()+1,
					tgYear = tgDate.getFullYear(),
					tgDay = tgDate.getDate();
			let t1 = Math.floor(t/12),
				  t2 = t%12,
				  t3 = tgMonth-t2;

			tgYear = tgYear - t1;
			if(t3 <= 0){
				tgYear = tgYear -1;
				tgMonth =  12 + t3;
			}else{
				tgMonth = t3;
			}
			return `${tgYear}${ac}${tgMonth}${ac}${tgDay}`;
		},

		getMonthStartDay: function(t,ac='-') {
			let tgDate = new Date(),
					tgMonth = tgDate.getMonth()+1,
					tgYear = tgDate.getFullYear(),
					tgDay = tgDate.getDate();
			if(t <= tgMonth) {
				return `${tgYear}${ac}${t}${ac}1`;
			} else {
				return `${tgYear-1}${ac}${t}${ac}1`;
			}
		},
		getMonthEndDay: function(t,ac='-') {
			let tgDate = new Date(),
					tgMonth = tgDate.getMonth()+1,
					tgYear = tgDate.getFullYear(),
					tgDay = tgDate.getDate();

			if(t==1||t==3||t==5||t==7||t==8||t==10||t==12) {
				tgDay = 31;
			} else if(t==4||t==6||t==9||t==11) {
				tgDay = 30;
			}

			if(t <= tgMonth) {
				//判断闰年
				if((tgYear % 4 == 0&&tgYear % 100 != 0) || tgYear % 400 == 0) {
					if(t == 2) {
						tgDay = 29;
					}
				} else {
					if(t == 2) {
						tgDay = 28;
					}
				}
				return `${tgYear}${ac}${t}${ac}${tgDay}`;
			} else {
				let _year = tgYear-1;
				if((_year % 4 == 0&&_year % 100 != 0) || _year % 400 == 0) {
					if(t == 2) {
						tgDay = 29;
					}
				} else {
					if(t == 2) {
						tgDay = 28;
					}
				}
				return `${_year}${ac}${t}${ac}${tgDay}`;
			}
		},
		open(e,type) {
      // 设置类型
      this.calendar.picker=type
      this.calendar.type=this.calendar.items[type].type
      this.calendar.value=this.calendar.items[type].value
      // 可不用写
      this.calendar.sep=this.calendar.items[type].sep

      this.calendar.show=true
      this.calendar.x=e.target.offsetLeft
      this.calendar.y=e.target.offsetTop+e.target.offsetHeight+8;
      if(type==="beginTime"){
      	this.calendar.end=this.calendar.items.endTime.value || this.calendar.items.endTime.end;
      	this.calendar.begin="";
      }else{
      	this.calendar.begin=this.calendar.items.startTime.value;
      	this.calendar.end=this.calendar.items.endTime.end;
      }
  	}

	},

	events:{
    [dropMenuEvent.menu.change](opt){
      let qName = opt.queryName;
      if(qName =='searchMonth'){
        let _val = opt.optionItem.value;
        if(_val!==-1) {
        	this.timeSet(2, _val);
        }
        return;
      }
    }
  },

}

module.exports = UserSurvey;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/userdata/user-survey/user-survey.js